var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "13.304", viewBox: "0 0 15 13.304" }, props),
    React.createElement(
      "g",
      { transform: "translate(-185 -254)" },
      React.createElement("path", { className: styles["a"] || "a", d: "M186.188 254.185h2.053v12.918h-2.053zM191.473 254.185h2.053v12.918h-2.053zM196.759 254.185h2.053v12.918h-2.053z" }),
      React.createElement("circle", { className: styles["a"] || "a", cx: "2.215", cy: "2.215", r: "2.215", transform: "translate(195.571 258.429)" }),
      React.createElement("circle", { className: styles["a"] || "a", cx: "2.215", cy: "2.215", r: "2.215", transform: "translate(185 262.875)" }),
      React.createElement("circle", { className: styles["a"] || "a", cx: "2.215", cy: "2.215", r: "2.215", transform: "translate(190.285 254)" })
    )
  );
});